import React, { useEffect, useState, } from 'react';
import { ActivityIndicator, Dimensions, FlatList, Image, ImageBackground, Platform, Pressable, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import { ButtonSizeDLS, ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { ModalAlignmentEnum, SCREEN_SIZE, } from '@voltmoney/types';
import BottomSheet from '../BottomSheet';
import { Typography } from '../../typography/Typography';
import { Icon } from '../../icon/Icon';
import { Space } from '../../space/Space';
import { Button } from '../../button/Button';
import { Header } from '../../header/Header';
import { isMobile, isMobileView } from '../../stack/utils';
import { addCommasToNumber, getParameters } from "../utils";
import AssetDetails from "../AssetDetails";
import { HeaderDefaultBase } from "../../header/HeaderDefault.Base";
import ThemeProvider from '@voltmoney/theme';
import { PLATFORM_NAME } from '../constants';
import ButtonDLSBase from '../../button/ButtonDLS.base';
const ViewPortfolio = ({ bankData, profileAction, stepperData, triggerAction, backAction, applyAction, skipBankAction, modalState, continuePress, userName, height, creditLimit, showMailLoader, loading, showIncreaseLimit, showUnpledege, allowUnpledge, viewDetailsAction, directRemovePledgeStepsAction, navigateToPledgeHistoryAction, unpledgeData, loanNotOpenedForPledgeMore, loanNotOpenedForRemovePledge, showLeinRemovalTracking, showLoader, showRemovePledgeModal, showErrorModal, 
//  closeErrorModal,
counter, fundAmount, isLoanExpired, }) => {
    let eligibleFilters = [];
    const [errorModal, setErrorModal] = useState(showErrorModal);
    const [accountOpeningModal, setAccountOpeningModal] = useState(false);
    const [accountOpeningModalUnpledge, setAccountOpeningModalUnpledge] = useState(false);
    const [showLoanExpiredModal, setShowLoanExpiredModal] = useState(false);
    const [expiredDescription, setExpiredDescription] = useState('');
    const [isLoading, setLoading] = useState(showLoader);
    const mobHeight = Dimensions.get('window').height;
    const [showModal, setShowModal] = useState(false);
    const [selectedList, setSelectedList] = useState([]);
    const [creditValue, setCreditValue] = useState(0);
    const [showEmailLoader, setShowEmailLoader] = useState(false);
    const [showPayInfoModal, setShowPayInfoModal] = useState(showRemovePledgeModal);
    const [filtersSections, setFiltersSection] = useState([]);
    const [showUnpledgeModal, setShowUnpledgeModal] = useState(false);
    const [pledgeMoreClicked, setPledgeMoreClicked] = useState(false);
    const [list, setList] = useState({});
    const [flatData, setFlatData] = useState([]);
    const [cardState, setModalState] = useState('Penny');
    const [modalHeight, setModalHeight] = useState(332);
    const [isDismissable, setDismissable] = useState(false);
    const [filterData, setFilterData] = useState([]);
    const [filterName, setFilterName] = useState('EQUITY');
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    useEffect(() => {
        setShowEmailLoader(false);
    }, [showMailLoader]);
    useEffect(() => {
        setLoading(showLoader);
    }, [showLoader, counter]);
    useEffect(() => {
        setShowPayInfoModal(showRemovePledgeModal);
    }, [showRemovePledgeModal, counter]);
    useEffect(() => {
        setErrorModal(showErrorModal);
    }, [showErrorModal, counter]);
    const setInitialData = () => {
        bankData?.map((item) => {
            if (eligibleFilters.includes(item.assetSubType)) {
                // Do nothing basically
            }
            else {
                eligibleFilters.push(item.assetSubType);
            }
        });
        setFiltersSection(eligibleFilters);
    };
    useEffect(() => {
        if (modalState) {
            if (modalState === 'error') {
                setDismissable(true);
                setModalHeight(244);
            }
            if (modalState === 'success') {
                setModalHeight(228);
            }
            setModalState(modalState);
        }
        else {
            setModalState('Penny');
        }
    }, [modalState]);
    useEffect(() => {
        setFlatData(bankData);
    }, [bankData]);
    let isFromTdl = false;
    if (Platform.OS === 'web') {
        let params = getParameters(window.location.href);
        isFromTdl = params.platform === PLATFORM_NAME.TDL;
    }
    const emailHeaderChild = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
            } },
            React.createElement(View, { style: { flexDirection: 'row' } },
                React.createElement(View, { style: {
                        alignContent: 'center',
                        justifyContent: 'center',
                        marginRight: 12,
                    } },
                    React.createElement(Pressable, { nativeID: 'bt_pledgeMF_goBack', onPress: () => {
                            if (backAction) {
                                triggerAction(backAction);
                            }
                        }, style: {} },
                        React.createElement(Icon, { name: IconTokens.BackArrowIcon, size: IconSizeTokens.MD, color: ColorTokens.Grey_Night }))),
                React.createElement(Typography, { label: 'Pledged mutual funds', typeDLS: TypographyTypeDLS.H3R, color: ColorTokens.Grey_Night })),
            !isFromTdl && React.createElement(View, null,
                React.createElement(TouchableOpacity, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        paddingVertical: 4,
                        paddingHorizontal: 8,
                        backgroundColor: '#F3F5FC',
                        borderRadius: 24,
                        alignItems: 'center'
                    }, onPress: () => {
                        setShowEmailLoader(true);
                        if (skipBankAction) {
                            triggerAction(skipBankAction);
                        }
                    } },
                    React.createElement(Icon, { name: IconTokens.Email, size: IconSizeTokens.XL, color: ColorTokens.Primary_100 }),
                    React.createElement(View, { style: { width: 4 } }),
                    React.createElement(Typography, { label: 'Email', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXS, fontWeight: '500', lineHeight: 16, color: ColorTokens.Primary_100 }),
                    React.createElement(View, { style: { width: 8 } }),
                    showEmailLoader && React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100], size: 8 })))));
    };
    const returnWarnBox = () => {
        return showLeinRemovalTracking ? (React.createElement(View, { style: {
                paddingTop: 16,
                paddingHorizontal: 16,
                alignItems: 'center',
                zIndex: 2,
                marginBottom: showLeinRemovalTracking ? 10 : 8,
                ...Platform.OS !== "web" && {
                    height: pledgeMoreClicked && loanNotOpenedForPledgeMore ? 290 : pledgeMoreClicked ? Platform.OS === "ios" ? 366 : 360 : 290
                },
            } },
            React.createElement(Icon, { name: IconTokens.InfoFilled, size: IconSizeTokens.XXXXXXL, color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: { marginTop: 16, alignItems: 'center', alignContent: 'center' } },
                React.createElement(Typography, { label: pledgeMoreClicked ? loanNotOpenedForPledgeMore ? "We are temporarily unavailable" : "Pledge more request in progress" : loanNotOpenedForRemovePledge ? "We are temporarily unavailable" : "Unpledge request in progress", color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.H3S }),
                React.createElement(View, { style: { backgroundColor: '#F1F3F5', marginTop: 4, borderRadius: 8 } },
                    React.createElement(View, { style: { padding: 16 } },
                        React.createElement(Typography, { fontSize: FontSizeTokens.SM, textAlign: TextAlignTokens.left, label: pledgeMoreClicked ? loanNotOpenedForPledgeMore ? "Pledging more funds is not available at the moment. Please wait while we solve it on a priority." : "We’re processing your previous request to pledge funds. You cannot place a new request until then." : loanNotOpenedForRemovePledge ? "Removing pledge from funds is not available at the moment. Please wait while we solve it on a priority." : "We’re processing your previous request to unpledge funds. You cannot place a new request until then.", color: ColorTokens.Grey_Charcoal })))),
            React.createElement(View, { style: {
                    flexDirection: 'column',
                    marginTop: 24,
                    flex: 1,
                    width: '100%',
                } },
                (pledgeMoreClicked && loanNotOpenedForPledgeMore) ? React.createElement(React.Fragment, null) : loanNotOpenedForRemovePledge ? React.createElement(React.Fragment, null) :
                    React.createElement(Button, { id: 'bt_unpledgeRequest_viewDetails', onPress: () => {
                            setShowUnpledgeModal(false);
                            if (viewDetailsAction) {
                                if (pledgeMoreClicked) {
                                    triggerAction({
                                        ...viewDetailsAction,
                                        payload: {
                                            value: ''
                                        }
                                    });
                                }
                                else {
                                    triggerAction({
                                        ...viewDetailsAction,
                                        payload: {
                                            value: unpledgeData
                                        }
                                    });
                                }
                            }
                        }, type: ButtonTypeTokens.LargeSoftFilled, label: "View existing request", width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM }),
                React.createElement(View, { style: { marginTop: pledgeMoreClicked && loanNotOpenedForPledgeMore ? 0 : loanNotOpenedForRemovePledge ? 0 : 8 } },
                    React.createElement(Button, { id: 'bt_unpledgeRequest_gotIt', onPress: () => {
                            setShowUnpledgeModal(false);
                        }, type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, label: "Got it", fontSize: FontSizeTokens.SM }))))) : (React.createElement(View, { style: {
                padding: 16,
                alignItems: 'center',
                zIndex: 2,
                paddingTop: 24,
                ...Platform.OS !== "web" && {
                    paddingBottom: 12,
                    height: 370,
                }
            } },
            React.createElement(Icon, { name: IconTokens.InfoFilled, size: IconSizeTokens.Size52, color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: { marginTop: 24, alignItems: 'center' } },
                React.createElement(Typography, { label: "Unpledge request in progress", color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins, lineHeight: 28, fontWeight: '600', fontSize: FontSizeTokens.XL }),
                React.createElement(View, { style: { backgroundColor: '#F1F3F5', marginTop: 8, borderRadius: 8 } },
                    React.createElement(View, { style: { padding: 16 } },
                        React.createElement(Typography, { fontSize: FontSizeTokens.SM, textAlign: TextAlignTokens.left, label: "We’re processing your previous request to unpledge funds. You cannot place a new request until then.", color: ColorTokens.Grey_Charcoal })))),
            React.createElement(View, { style: {
                    flexDirection: 'column',
                    marginTop: 16,
                    flex: 1,
                    width: '100%',
                } },
                React.createElement(Button, { id: 'bt_unpledgeRequest_viewDetails', onPress: () => {
                        if (viewDetailsAction) {
                            triggerAction({
                                ...viewDetailsAction,
                                payload: {
                                    value: unpledgeData
                                }
                            });
                        }
                    }, type: ButtonTypeTokens.LargeSoftFilled, label: "View details", width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM }),
                React.createElement(View, { style: { marginTop: 12 } },
                    React.createElement(Button, { id: 'bt_unpledgeRequest_gotIt', onPress: () => {
                            setShowUnpledgeModal(false);
                        }, type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, label: "Got it", fontSize: FontSizeTokens.SM })))));
    };
    const renderInfoBox = () => {
        return (React.createElement(View, { style: {
                padding: 16,
            } },
            React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, label: "Credit Limit" }),
            React.createElement(View, { style: { marginTop: 24, borderColor: '#E4E7EC', borderWidth: 1, borderRadius: 8, padding: 12 } },
                React.createElement(View, { style: {
                        marginTop: 16,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(Typography, { label: 'Credit limit against portfolio', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(creditValue), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Available credit limit', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal })),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(creditLimit), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Secondary_100 })),
                React.createElement(View, { style: { height: 1, width: '100%', backgroundColor: "#E4E7EC", marginTop: 16 } }, " "),
                React.createElement(View, { style: {
                        marginTop: 16,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Credit limit', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Night })),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(creditValue), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Secondary_100 })))));
    };
    const calculateSumOfAssetPledgedValue = (assets) => {
        let sum = 0;
        for (const asset of assets) {
            sum += asset.assetPledgedValue;
        }
        return Math.floor(sum);
    };
    const modalContentPresenter = () => {
        return renderInfoBox();
    };
    useEffect(() => {
        let listObj = {
            eligibleAssetData: bankData,
            nonEligibleAssetData: []
        };
        setInitialData();
        setList(listObj);
        setCreditValue(fundAmount);
        return () => {
            setModalHeight(332);
            setModalState('Penny');
            setShowModal(false);
        };
    }, []);
    const sectionCard = (title, iconName, action) => {
        return (React.createElement(TouchableOpacity, { style: {
                flex: 1,
                height: 80,
                borderRadius: 4,
                backgroundColor: 'white',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
                marginLeft: title.includes("More") ? 0 : 8
            }, activeOpacity: 1, onPress: async () => {
                if (title.includes("Remove")) {
                    if (isLoanExpired) {
                        setShowLoanExpiredModal(true);
                        setExpiredDescription('Cannot un-pledge assets if your loan account is expired.');
                    }
                    else if (allowUnpledge && !loanNotOpenedForRemovePledge && showUnpledege && !isLoading) {
                        await triggerAction({
                            ...action,
                            payload: {
                                ...action.payload,
                            }
                        });
                    }
                    else {
                        if (!showUnpledege) {
                            setAccountOpeningModalUnpledge(true);
                        }
                        else {
                            setPledgeMoreClicked(false);
                            setShowUnpledgeModal(true);
                        }
                    }
                }
                else if (title.includes("More")) {
                    if (isLoanExpired) {
                        setShowLoanExpiredModal(true);
                        setExpiredDescription('Cannot pledge more assets if your loan account is expired.');
                    }
                    else if (showIncreaseLimit && !loanNotOpenedForPledgeMore && !loading) {
                        await triggerAction({
                            ...action,
                            payload: {
                                ...action.payload,
                            }
                        });
                        setPledgeMoreClicked(false);
                    }
                    else {
                        if (loanNotOpenedForPledgeMore) {
                            setAccountOpeningModal(true);
                        }
                        else {
                            setPledgeMoreClicked(true);
                            setShowUnpledgeModal(true);
                        }
                    }
                }
                else {
                    triggerAction({
                        ...action,
                        payload: {
                            ...action.payload,
                        }
                    });
                }
            } },
            (title.includes("Remove") && isLoading) ? (React.createElement(View, { style: { marginLeft: 4 } },
                React.createElement(ActivityIndicator, { color: '#1434CB', size: 24 }))) : (title.includes("More") && loading ? (React.createElement(View, { style: { marginLeft: 4 } },
                React.createElement(ActivityIndicator, { color: '#1434CB', size: 24 }))) : (React.createElement(Icon, { name: iconName, size: IconSizeTokens.XXL, color: ColorTokens.Primary_100 }))),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: title, textAlign: TextAlignTokens.center, color: ColorTokens.Grey_Night }))));
    };
    const _bodyChild = () => {
        // @ts-ignore
        return showLeinRemovalTracking ? (React.createElement(View, null,
            React.createElement(View, { style: { backgroundColor: colorMapping[ColorTokens.Primary_05] } },
                React.createElement(View, { style: {
                        marginTop: 16,
                        borderRadius: 8,
                        marginRight: 16,
                        marginLeft: 16,
                        paddingBottom: 12,
                        backgroundColor: 'white',
                        paddingTop: 12,
                        paddingHorizontal: 16
                    } },
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        } },
                        React.createElement(Typography, { label: 'Portfolio value', color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B0M }),
                        React.createElement(Typography, { label: '₹' + addCommasToNumber(creditValue), typeDLS: TypographyTypeDLS.B0S, color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            marginTop: 12,
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        } },
                        React.createElement(View, null,
                            React.createElement(Typography, { label: 'Available credit limit', color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B0M })),
                        React.createElement(Typography, { label: '₹' + addCommasToNumber(creditLimit), typeDLS: TypographyTypeDLS.B0S, color: ColorTokens.Secondary_100 })))),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    paddingHorizontal: 16,
                    paddingTop: 12,
                    paddingBottom: 16,
                    backgroundColor: colorMapping[ColorTokens.Primary_05],
                } },
                sectionCard("Pledge\nMore", IconTokens.PLEDGE_MORE, continuePress),
                sectionCard("Remove\nPledge", IconTokens.REMOVE_PLEDGE, directRemovePledgeStepsAction),
                sectionCard("Pledge\nHistory", IconTokens.HISTORY_BLUE, navigateToPledgeHistoryAction)),
            Object.keys(list).length
                !== 0 && React.createElement(AssetDetails, { data: [selectedList], dataa: list, flatData: flatData, onFitlerSet: () => {
                    console.warn("ELIGIBLE FILTERS ARE ", eligibleFilters);
                    setShowModal(true);
                    setFilterData(bankData.filter((item) => item.assetSubType === filtersSections[0]));
                    setFilterName(filtersSections[0]);
                }, isFromEligible: true, triggerAction: triggerAction, height: height - 20 }))) : (React.createElement(View, null,
            React.createElement(View, { style: { marginTop: 24, borderColor: '#E4E7EC', borderWidth: 1, borderRadius: 8, margin: 16 } },
                React.createElement(View, { style: {
                        marginTop: 16,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                        paddingHorizontal: 12
                    } },
                    React.createElement(Typography, { label: 'Value', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night }),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(creditValue), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '500', color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                        paddingHorizontal: 12
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Available credit limit', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night })),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(creditLimit), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '500', color: ColorTokens.Secondary_100 })),
                React.createElement(View, { style: { height: 1, width: '100%', backgroundColor: '#E4E7EC', marginTop: 12, } }),
                showIncreaseLimit && showUnpledege &&
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                        React.createElement(View, { nativeID: 'txt_pledgeMF_pledgeMore', style: {
                                justifyContent: 'center',
                                alignItems: 'center',
                                alignContent: 'center',
                                flex: 0.5,
                                borderRightWidth: 1,
                                borderColor: '#E4E7EC'
                            } },
                            React.createElement(TouchableOpacity, { style: { padding: 12, display: 'flex', flexDirection: 'row', alignItems: 'center' }, onPress: () => {
                                    if (!loading && continuePress) {
                                        triggerAction(continuePress);
                                    }
                                } },
                                React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontWeight: '600', lineHeight: 20, fontSize: FontSizeTokens.SM, color: ColorTokens.Primary_100, label: loading ? "Pledge more" : "Pledge more >" }),
                                React.createElement(View, { style: { width: 9 } }),
                                loading &&
                                    React.createElement(React.Fragment, null,
                                        React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100] })))),
                        React.createElement(View, { nativeID: 'txt_pledgeMF_removePledge', style: { justifyContent: 'center', alignItems: 'center', flex: 0.5 } },
                            React.createElement(TouchableOpacity, { style: { padding: 12 }, onPress: () => {
                                    if (applyAction) {
                                        if (allowUnpledge) {
                                            triggerAction(applyAction);
                                        }
                                        else {
                                            setShowUnpledgeModal(true);
                                        }
                                    }
                                } },
                                React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontWeight: '600', lineHeight: 20, fontSize: FontSizeTokens.SM, color: ColorTokens.Primary_100, label: "Remove pledge >" })))),
                showIncreaseLimit && !showUnpledege && React.createElement(View, null,
                    React.createElement(View, { style: {
                            justifyContent: 'center',
                            alignItems: 'center',
                            alignContent: 'center',
                            borderRightWidth: 1,
                            borderColor: '#E4E7EC'
                        } },
                        React.createElement(TouchableOpacity, { style: { padding: 12, display: 'flex', flexDirection: 'row', alignItems: 'center' }, onPress: () => {
                                if (!loading && continuePress) {
                                    triggerAction(continuePress);
                                }
                            } },
                            React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontWeight: '600', lineHeight: 20, fontSize: FontSizeTokens.SM, color: ColorTokens.Primary_100, label: loading ? "Pledge more" : "Pledge more >" }),
                            React.createElement(View, { style: { width: 9 } }),
                            loading &&
                                React.createElement(React.Fragment, null,
                                    React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100] }))))),
                !showIncreaseLimit && showUnpledege && React.createElement(View, null,
                    React.createElement(View, { style: {
                            justifyContent: 'center',
                            alignItems: 'center',
                            alignContent: 'center',
                            borderRightWidth: 1,
                            borderColor: '#E4E7EC'
                        } },
                        React.createElement(TouchableOpacity, { style: { padding: 12 }, onPress: () => {
                                if (applyAction) {
                                    if (allowUnpledge) {
                                        triggerAction(applyAction);
                                    }
                                    else {
                                        setShowUnpledgeModal(true);
                                    }
                                }
                            } },
                            React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontWeight: '600', lineHeight: 20, fontSize: FontSizeTokens.SM, color: ColorTokens.Primary_100, label: "Remove pledge >" }))))),
            React.createElement(View, { style: {
                    backgroundColor: colorMapping[ColorTokens.Primary_05],
                    borderTopWidth: 1,
                    borderBottomWidth: 1,
                    borderColor: '#E7EBFA',
                    height: 16,
                    width: '100%',
                    marginTop: 8
                } }),
            Object.keys(list).length
                !== 0 && React.createElement(AssetDetails, { data: [selectedList], dataa: list, flatData: flatData, onFitlerSet: () => {
                    console.warn("ELIGIBLE FILTERS ARE ", eligibleFilters);
                    setShowModal(true);
                    setFilterData(bankData.filter((item) => item.assetSubType === filtersSections[0]));
                    setFilterName(filtersSections[0]);
                }, isFromEligible: true, triggerAction: triggerAction, height: height })));
    };
    // const handleErrorModal = async() => {
    //     if(closeErrorModal){
    //         await triggerAction(closeErrorModal);
    //     }
    // }
    const ChecklistItem = ({ item, onPress }) => {
        const [isChecked, setIsChecked] = useState(false);
        const handlePress = (item) => {
            console.warn('IN THIS ');
            setIsChecked(!isChecked);
            // handleItemPress(item.isin);
        };
        return (React.createElement(View, { style: {
                paddingVertical: 16,
                paddingLeft: 10,
                paddingRight: 15,
                justifyContent: 'center',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    alignContent: 'center',
                } },
                React.createElement(TouchableOpacity, { style: { paddingRight: 2, paddingLeft: 2 }, onPress: () => {
                        let data = selectedList;
                        console.warn('SEL data prior ', data);
                        const index = data.indexOf(item.isinCode);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item.isinCode);
                        }
                        console.warn('SEL data ', data);
                        setSelectedList(data);
                        setFilterData(bankData.filter((item) => item.assetSubType === filterName));
                    } },
                    React.createElement(Icon, { name: selectedList.includes(item.isinCode)
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        let data = selectedList;
                        console.warn('SEL data prior ', data);
                        const index = data.indexOf(item.isinCode);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item.isinCode);
                        }
                        console.warn('SEL data ', data);
                        setSelectedList(data);
                        setFilterData(bankData.filter((item) => item.assetSubType === filterName));
                    }, style: { width: '100%', marginLeft: 8, paddingRight: 16 } },
                    React.createElement(Typography, { label: item.assetName, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Night })))));
    };
    const applyFilter = () => {
        let filteredData = [];
        if (selectedList.length === 0) {
            let listObj = {
                eligibleAssetData: bankData,
                nonEligibleAssetData: []
            };
            setFlatData(filteredData);
            setList(listObj);
            setFlatData(bankData);
            return;
        }
        bankData.map((item) => {
            selectedList.includes(item.isinCode)
                ? filteredData.push(item)
                : null;
        });
        let listObj = {
            eligibleAssetData: filteredData,
            nonEligibleAssetData: []
        };
        setFlatData(filteredData);
        setList(listObj);
    };
    useEffect(() => {
    }, [list]);
    const returnFilter = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: {
                height: Platform.OS === "ios"
                    ? height - 47
                    : Platform.OS === 'android'
                        ? height - 57
                        : height - 100,
                zIndex: 1
            } },
            React.createElement(View, null,
                React.createElement(HeaderDefaultBase, { title: 'Filter' })),
            React.createElement(View, { style: height ? {
                    flexDirection: 'row',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                    flex: 1,
                } : {
                    flexDirection: 'row',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                } },
                React.createElement(FlatList, { style: {
                        width: 150,
                        backgroundColor: '#F9FAFB',
                        ...Platform.OS === 'ios' && { paddingBottom: 120 }
                    }, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                            backgroundColor: '#E4E7EC',
                            height: 1,
                        } })), data: filtersSections, renderItem: ({ item }) => (React.createElement(View, { nativeID: 'txt_pledgeMf_' + item },
                        React.createElement(TouchableOpacity, { style: {
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                padding: 20,
                            }, onPress: () => {
                                setFilterData(bankData.filter((items) => items.assetSubType === item));
                                setFilterName(item);
                            } }, React.createElement(Typography, { label: item, 
                            // color={filterName === item
                            // 	? ColorTokens.Grey_Night
                            // 	: ColorTokens.Grey_Charcoal}
                            fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter })))) }),
                React.createElement(View, { style: {
                        width: 1,
                        height: '100%',
                        backgroundColor: '#E4E7EC',
                    } }),
                React.createElement(ScrollView, { nestedScrollEnabled: true, contentContainerStyle: {
                        paddingBottom: Platform.OS !== 'web' ? 120 : 0
                    }, style: height ?
                        {
                            flex: 1,
                            paddingBottom: 160,
                            paddingHorizontal: 16,
                        } : {
                        height: 550
                    } }, filterData.map((item, index) => {
                    return (React.createElement(View, { nativeID: 'cb_pledgeMf_' + (index + 1) },
                        React.createElement(ChecklistItem, { item: item, onPress: () => {
                                console.warn("ITEM PRESSED", item);
                            } }),
                        React.createElement(View, { style: { backgroundColor: '#E4E7EC', height: 1 } })));
                }))),
            React.createElement(View, { style: {
                    height: Platform.OS === 'ios' ? 76 : 88,
                    position: "absolute",
                    bottom: Platform.OS !== 'ios' ? -5 : 0,
                    flexDirection: 'row',
                    backgroundColor: 'white',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderWidth: 1,
                    borderColor: '#ddd',
                    borderBottomWidth: 0,
                    shadowColor: '#000000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.9,
                    shadowRadius: 3,
                    elevation: 5,
                    paddingTop: 16,
                    paddingBottom: 16,
                    paddingHorizontal: 16,
                    ...Platform.OS === "ios" && { paddingBottom: 6 },
                } },
                React.createElement(View, { nativeID: 'bt_pledgeMf_resetFilter', style: { flex: 0.5, marginRight: 8 } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: "Reset filter", fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            setSelectedList([]);
                            let listObj = {
                                eligibleAssetData: bankData,
                                nonEligibleAssetData: []
                            };
                            setFlatData(bankData);
                            setList(listObj);
                            return;
                        } })),
                React.createElement(View, { nativeID: 'bt_pledgeMf_apply', style: { flex: 0.5 } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, label: "Apply", onPress: () => {
                            applyFilter();
                            setShowModal(false);
                        } })))));
    };
    const renderPaymentInfo = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XXXXXXL })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Insufficient un-pledge limit" })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "A 10% buffer needs to be maintained on dues to account for market fluctuations. Please repay to un-pledge funds.", color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Got it', onPress: () => setShowPayInfoModal(false), isDisabled: false }))));
    };
    const renderErrorModal = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XXXXXXL })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Service temporarily unavailable." })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "We\u2019re experiencing a temporary issue with our lending partner. Please try again after sometime", color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Got it', onPress: () => setErrorModal(false), isDisabled: false }))));
    };
    const renderAccountOpeningModal = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XXXXXXL })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Account set up in-progress" })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "You\u2019ll be able to pledge more funds as soon as the account set up is complete. Please try again after sometime", color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Got it', onPress: () => setAccountOpeningModal(false), isDisabled: false }))));
    };
    const renderAccountOpeningModalUnpledge = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XXXXXXL })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Account set up in-progress" })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "You\u2019ll be able to remove pledge from funds as soon as the account set up is complete. Please try again after sometime", color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Got it', onPress: () => setAccountOpeningModalUnpledge(false), isDisabled: false }))));
    };
    const renderExpiredModal = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_REDBG_DLS, size: IconSizeTokens.XXXXXXL })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Your loan has expired" })),
            React.createElement(View, { style: { marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: expiredDescription, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Got it', onPress: () => setShowLoanExpiredModal(false), isDisabled: false }))));
    };
    const renderMainBody = () => {
        return (React.createElement(View, { style: [
                styles.container,
                { height: Platform.OS === "ios" ? height - 15 : height - 25 }
            ] },
            React.createElement(View, { style: {
                    flex: 1
                } },
                React.createElement(View, { style: styles.header }, emailHeaderChild()),
                React.createElement(View, { style: [{ height: height - 134 }] }, _bodyChild())),
            showModal &&
                React.createElement(View, { style: {
                        position: 'absolute',
                        bottom: 0,
                        marginTop: 12
                    } },
                    React.createElement(BottomSheet, { id: 'bt_pledgeMf_cancel', autoAdjustHeight: false, height: Platform.OS === 'ios' ?
                            height - 50 :
                            Platform.OS === 'android' ?
                                height - 57
                                : height - 136, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: Platform.OS === 'web' ? height : mobHeight, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, returnFilter())),
            showUnpledgeModal &&
                React.createElement(View, { style: Platform.OS !== 'web' ? {
                        position: 'absolute',
                        paddingBottom: 8
                    } : {
                        position: 'absolute',
                    } },
                    React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobileView()
                            ? pledgeMoreClicked && loanNotOpenedForPledgeMore
                                ? Platform.OS !== "web" ? Platform.OS === "ios" ? 300 : 290 : 302
                                : loanNotOpenedForRemovePledge
                                    ? Platform.OS !== "web" ? Platform.OS === "ios" ? 300 : 290 : 290
                                    : Platform.OS !== "web" ? pledgeMoreClicked ? Platform.OS === "ios" ? 374 : 370 : 340 : 352
                            : showLeinRemovalTracking
                                ? pledgeMoreClicked && loanNotOpenedForPledgeMore
                                    ? 282
                                    : loanNotOpenedForRemovePledge
                                        ? 282
                                        : 328
                                : Platform.OS !== "web" ? 310 : 340, width: '100%', closeFunction: () => setShowUnpledgeModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: Platform.OS === 'web' ? showLeinRemovalTracking ? height + 36 : height + 12 : mobHeight + 12, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, hideMarginBottom: true }, returnWarnBox())),
            showPayInfoModal &&
                React.createElement(View, { style: Platform.OS !== 'web' ? {
                        position: 'absolute',
                        paddingBottom: 8
                    } : {
                        position: 'absolute',
                        flex: 1,
                        bottom: -8
                    } },
                    React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobile(getScreenType(Dimensions.get('window').width)) ? 284 : 258, width: '100%', closeFunction: () => setShowPayInfoModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, hideMarginBottom: true }, renderPaymentInfo())),
            errorModal &&
                React.createElement(View, { style: {
                        position: 'absolute',
                        flex: 1,
                        bottom: -8
                    } },
                    React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobile(getScreenType(Dimensions.get('window').width)) ? 274 : 258, width: '100%', closeFunction: () => { setErrorModal(false); }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, hideMarginBottom: true }, renderErrorModal())),
            accountOpeningModal &&
                React.createElement(View, { style: {
                        position: 'absolute',
                        flex: 1,
                        bottom: -8
                    } },
                    React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobile(getScreenType(Dimensions.get('window').width)) ? 284 : 258, width: '100%', closeFunction: () => { setAccountOpeningModal(false); }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, hideMarginBottom: true }, renderAccountOpeningModal())),
            accountOpeningModalUnpledge &&
                React.createElement(View, { style: {
                        position: 'absolute',
                        flex: 1,
                        bottom: -8
                    } },
                    React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobile(getScreenType(Dimensions.get('window').width)) ? 284 : 258, width: '100%', closeFunction: () => { setAccountOpeningModalUnpledge(false); }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, hideMarginBottom: true }, renderAccountOpeningModalUnpledge())),
            showLoanExpiredModal &&
                React.createElement(View, { style: {
                        position: 'absolute',
                        flex: 1,
                        bottom: -8
                    } },
                    React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobile(getScreenType(Dimensions.get('window').width)) ? 240 : 220, width: '100%', closeFunction: () => { setShowLoanExpiredModal(false); }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, hideMarginBottom: true }, renderExpiredModal()))));
    };
    return renderMainBody();
    return (React.createElement(View, { style: [styles.container, { height: Platform.OS === "ios" ? height - 15 : height }] },
        React.createElement(View, { style: styles.contentContainer },
            React.createElement(Header, { type: HeaderTypeTokens.DEFAULT, title: 'Manage limit' }),
            React.createElement(ImageBackground, { source: {
                    uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/background_purple.png',
                }, imageStyle: { borderRadius: 16 }, style: styles.groupLayout },
                React.createElement(View, { style: {
                        padding: 16,
                        flexDirection: 'row',
                    } },
                    React.createElement(Image, { source: {
                            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/yellow_rupee.png',
                        }, style: { width: 56, height: 56 } }),
                    React.createElement(View, { style: { marginLeft: 9 } },
                        React.createElement(Typography, { label: 'Credit limit', color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '500', lineHeight: 20 }),
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                alignItems: 'center',
                            } },
                            React.createElement(Typography, { label: '₹3,00,000', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XXXXL, fontFamily: FontFamilyTokens.Inter, fontWeight: '700', lineHeight: 40 }),
                            React.createElement(TouchableOpacity, { onPress: () => {
                                    setShowModal(true);
                                }, style: { marginLeft: 5 } },
                                React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.XL, color: ColorTokens.Grey_Night })))))),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Button, { width: ButtonWidthTypeToken.FULL, label: 'Increase limit', type: ButtonTypeTokens.LargeFilled, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter })),
            React.createElement(View, { style: {
                    height: 1,
                    backgroundColor: '#E4E7EC',
                    marginTop: 24,
                } }),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Typography, { label: 'Pledged portfolio', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24 }),
                React.createElement(View, { style: [
                        styles.frameGroup,
                        {
                            marginTop: 16,
                            borderRadius: 8,
                            padding: 16,
                        },
                    ] },
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Image, { source: {
                                uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/image+1997.png',
                            }, style: { width: 26, height: 26 } }),
                        React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                        React.createElement(Typography, { label: 'Mutual funds', fontWeight: '600', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24 })),
                    React.createElement(View, { style: {
                            marginTop: 16,
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingTop: 2,
                        } },
                        React.createElement(Typography, { label: 'Value', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { label: '₹7,00,000', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            height: 1,
                            backgroundColor: '#E4E7EC',
                            marginTop: 16,
                            marginHorizontal: -16
                        } }),
                    React.createElement(View, { style: { marginTop: 13 } },
                        React.createElement(Typography, { label: 'View Details  >', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', color: ColorTokens.Primary_100, lineHeight: 20 }))))),
        showModal && (React.createElement(BottomSheet, { autoAdjustHeight: false, height: 208, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: isDismissable, radius: 4, screenHeight: Platform.OS === 'ios' ?
                height - 15 :
                isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                ? Dimensions.get('window').width
                : 508, routeId: 'routeId', handleKeyboard: true }, modalContentPresenter()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        marginHorizontal: -16,
    },
    blankContainer: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        width: '100%',
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        padding: 16,
        flex: 1, // pushes the footer to the end of the screen
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    groupContainer: {
        zIndex: 0,
    },
    groupLayout: {
        height: 88,
        width: '100%',
        borderRadius: 16,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14,
    },
    footer: {
        position: 'absolute',
        bottom: '0',
        zIndex: 99,
        width: '100%',
        // backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        // shadowColor: '#D0D5DD',
        // shadowOffset: { width: 0, height: 1 },
        // shadowOpacity: 0.25,
        // shadowRadius: 6,
        // elevation: 2,
        backgroundColor: 'rgb(255, 255, 255)',
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowOpacity: 0.5,
    },
    frameGroup: {
        borderRadius: 8,
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowRadius: 8,
        elevation: 8,
        borderColor: '#e4e7ec',
        paddingBottom: 61,
        marginTop: 16,
        borderStyle: 'solid',
        shadowOpacity: 1,
        shadowOffset: {
            width: 0,
            height: 2,
        },
    },
    itemContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 2,
        maxWidth: Dimensions.get('window').width < 576
            ? '85%'
            : '90%',
        marginLeft: 8,
    },
    itemText: {
        fontSize: 16,
        marginLeft: 3,
    },
    checkedItemText: {
        textDecorationLine: 'line-through',
    },
    header: {
        paddingHorizontal: 16,
        ...Platform.OS !== 'ios' ? {
            paddingTop: 12,
            paddingBottom: 12
        } : {
            marginTop: 36
        },
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        shadowOffset: { width: 0, height: 1 },
        shadowColor: 'rgba(208, 213, 221, 0.25)',
        shadowOpacity: 1,
        shadowRadius: 6,
        elevation: 1,
        height: 65,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
});
export default ViewPortfolio;
